import { type Offer, getAutoOpenWidgetUrlFromOffer } from '@funtech-int/yango-shared';

import { clientConfig } from '@/config/client';

const {
    defaultMediaBillingConfig: { target: DEFAULT_MEDIA_BILLING_TARGET },
} = clientConfig;
// TODO: remove in https://st.yandex-team.ru/SAFTWEB-1093

export function getAutoOpenWidgetUrl(offer?: Offer | null): URL | undefined {
    return getAutoOpenWidgetUrlFromOffer(offer, { defaultTarget: DEFAULT_MEDIA_BILLING_TARGET });
}
